import AlignButton from "./AlignButton";
import AlignPanel from "./AlignPanel";

export default {
    button: AlignButton,
    name: "align",
    panel: AlignPanel,
};
